module.exports = function(PluginManager) {
  PluginManager.registerAudienceMatcher('code', require('./matchers/code'));
};
